/* eslint-disable react-hooks/exhaustive-deps */
import { SERIES_OPTIONS } from "features/Crear/forms/Titulo"
import { newDocumentoSelector } from "features/Crear/redux/selectors/newDocumentoSelectors"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  setFacturaRecurrenteItems,
  setIsCompleteFacturaRecurrente,
  setIsInFacturasRecurrentes,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { INTERVALOS_KEYS_ARRAY } from "../../../Documentos/pages/FacturasRecurrentes/pages/FacturasRecurrentesDetail/constants"

const DocumentoFacturaRecurrenteFormHeader = ({
  titleDocumento,
  logo,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const documento = useSelector(newDocumentoSelector)
  const { showLogo } = useSelector(newDocumentoSettingsSelector)

  const [facturaRecurrenteValues, setFacturaRecurrenteValues] = useState({
    intervalo: documento.intervalo,
    fechaFin: null,
    fechaInicio: documento.fechaInicio,
    serie: documento.serie,
    fechaFinValida: false,
  })
  const handleSetValues = (
    value: $TSMigrationFixMe,
    key: $TSMigrationFixMe
  ) => {
    setFacturaRecurrenteValues({
      ...facturaRecurrenteValues,
      [key]: value,
    })
  }

  const checkIsComplete = useCallback(() => {
    const { fechaFin, fechaInicio } = facturaRecurrenteValues
    const allValuesAreSet = Object.values(facturaRecurrenteValues).length === 4
    const fecheFinIsInvalid = fechaFin === "Invalid date"
    const onlyfechaInicioSelected = allValuesAreSet && fechaInicio && !fechaFin
    const bothFechasSelected = allValuesAreSet && fechaInicio && fechaFin
    const fechaFinIsBigger =
      // @ts-expect-error TS(2769): No overload matches this call.
      new Date(fechaFin).getTime() > new Date(fechaInicio).getTime()

    return (
      onlyfechaInicioSelected ||
      (bothFechasSelected && (fechaFinIsBigger || fecheFinIsInvalid))
    )
  }, [facturaRecurrenteValues])

  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type '{ intervalo: $TSFixMe; fechaFin: $TSFixMe;...
    setFacturaRecurrenteValues({
      intervalo: documento.intervalo,
      fechaFin: documento.fechaFin,
      fechaInicio: documento.fechaInicio,
      serie: documento.serie,
    })
  }, [
    documento.fechaFin,
    documento.fechaInicio,
    documento.intervalo,
    documento.serie,
  ])

  useEffect(() => {
    dispatch(setIsInFacturasRecurrentes())
    if (checkIsComplete()) {
      // @ts-expect-error TS(2345): Argument of type '{ intervalo...
      dispatch(setFacturaRecurrenteItems(facturaRecurrenteValues))
      // @ts-expect-error TS(2345): Argument of type boolean ...
      dispatch(setIsCompleteFacturaRecurrente(true))
    } else {
      // @ts-expect-error TS(2345): Argument of type boolean ...
      dispatch(setIsCompleteFacturaRecurrente(false))
    }
    return () => {
      // @ts-expect-error TS(2345): Argument of type boolean ...
      dispatch(setIsCompleteFacturaRecurrente(false))
    }
  }, [checkIsComplete, dispatch, facturaRecurrenteValues])

  return (
    <div className='mb-4 d-flex justify-content-between'>
      <div className='col-5'>
        <div className='d-flex align-items-center justify-content-start'>
          {showLogo && logo && (
            <img
              style={{
                width: "200px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
              src={logo}
              // @ts-expect-error TS(2322): Type 'DefaultTFuncReturn' is not assignable to typ...
              alt={t("crear.facturaRec.logoFacLabel")}
              className='mr-3'
            />
          )}

          <h5>{titleDocumento?.toUpperCase()}</h5>
        </div>
      </div>

      <div className='d-flex facturar add-recurrente_options-container'>
        <div className='d-flex justify-content-center align-items-start flex-column'>
          <label htmlFor='importeDesde'>
            {t("crear.facturaRec.headerSerie")}
          </label>
          <Dropdown
            id='serie'
            name='serie'
            optionLabel='name'
            options={SERIES_OPTIONS}
            value={facturaRecurrenteValues.serie}
            onChange={(e) => handleSetValues(e.value, "serie")}
            // @ts-expect-error TS(2769): No overload matches this call.
            autoComplete='off'
          />
        </div>

        <div className='d-flex justify-content-center align-items-start flex-column'>
          <label htmlFor='importeDesde'>
            {t("crear.facturaRec.headerInterval")}
          </label>
          <Dropdown
            id='intervalos'
            name='intervalos'
            optionLabel='name'
            options={INTERVALOS_KEYS_ARRAY(t)}
            value={facturaRecurrenteValues.intervalo}
            onChange={(e) => handleSetValues(e.value, "intervalo")}
            // @ts-expect-error TS(2769): No overload matches this call.
            autoComplete='off'
          />
        </div>
        <div className='d-flex justify-content-center align-items-start flex-column'>
          <label htmlFor='importeDesde'>
            {t("crear.facturaRec.headerInit")}
          </label>
          <InputText
            onChange={(e) => handleSetValues(e.target.value, "fechaInicio")}
            value={facturaRecurrenteValues.fechaInicio}
            // @ts-expect-error TS(2769): No overload matches this call.
            minFractionDigits={2}
            type='date'
          />
        </div>
        <div className='d-flex justify-content-center align-items-start flex-column'>
          <label htmlFor='importeDesde'>
            {t("crear.facturaRec.hedaerFinish")}
          </label>
          <InputText
            onChange={(e) => {
              if (!e.target.value.length) {
                handleSetValues(new Date(), "fechaFin")
              } else {
                handleSetValues(e.target.value, "fechaFin")
              }
            }}
            // @ts-expect-error TS(2769): No overload matches this call.
            value={facturaRecurrenteValues.fechaFin}
            minFractionDigits={2}
            type='date'
          />
        </div>

        <div className='d-flex align-items-center justify-content-end' />
      </div>
    </div>
  )
}

export default DocumentoFacturaRecurrenteFormHeader
